import { fromJS } from 'immutable';
const action = name => `/master/${name}`;

//INTEGRATION MASTER
export const GET_ACTIVE_USER_AND_MST_INT = action('GET_ACTIVE_USER_AND_MST_INT');
export const GET_ACTIVE_INT = action('GET_ACTIVE_INT');
export const ACTIVE_DEACTIVE_USER_INTEGRATION = action('ACTIVE_DEACTIVE_USER_INTEGRATION');
export const GET_ACTIVE_USER_AND_MST_INT_SUCCESS = action('GET_ACTIVE_USER_AND_MST_INT_SUCCESS');
export const GET_ACTIVE_INT_SUCCESS = action('GET_ACTIVE_INT_SUCCESS');

export const getUsIntMst = data => ({ type: GET_ACTIVE_USER_AND_MST_INT, data });
export const getIntMstList = data => ({ type: GET_ACTIVE_INT, data });
export const usIntMstSuccess = data => ({ type: GET_ACTIVE_USER_AND_MST_INT_SUCCESS, data });
export const getIntMstListSuccess = data => ({ type: GET_ACTIVE_INT_SUCCESS, data });
export const updADUsInt = data => ({ type: ACTIVE_DEACTIVE_USER_INTEGRATION, data });

//COMMON SUCCESS FOR INTEGRATION
export const INT_SUCCESS = action('INT_SUCCESS');

export const intSuccess = data => ({ type: INT_SUCCESS, data });

//FACEBOOK_POST
export const GET_FACEBOOK_POST_INTEGRATION = action('GET_FACEBOOK_POST_INTEGRATION');
export const CREATE_IS_FACEBOOK_POST_PAGE_TRUE = action('CREATE_IS_FACEBOOK_POST_PAGE_TRUE');
export const DELETE_IS_FACEBOOK_POST_PAGE_FALSE = action('DELETE_IS_FACEBOOK_POST_PAGE_FALSE');
export const DELETE_FACEBOOK_POST_INTEGRATION = action('DELETE_FACEBOOK_POST_INTEGRATION');

export const getFBPostInt = data => ({ type: GET_FACEBOOK_POST_INTEGRATION, data });
export const createFBPage = data => ({ type: CREATE_IS_FACEBOOK_POST_PAGE_TRUE, data });
export const deleteFBList = data => ({ type: DELETE_IS_FACEBOOK_POST_PAGE_FALSE, data });
export const deleteFB = data => ({ type: DELETE_FACEBOOK_POST_INTEGRATION, data });

//FACEBOOK REVIEW
export const GET_FB_REVIEW_INT = action('GET_FB_REVIEW_INT');
export const CREATE_FACEBOOK_REVIEW_INTEGRATION = action('CREATE_FACEBOOK_REVIEW_INTEGRATION');
export const CREATE_FB_REVIEW_INT_IA = action('CREATE_FB_REVIEW_INT_IA');
export const DELETE_FB_REVIEW_INT_IA = action('DELETE_FB_REVIEW_INT_IA');
export const DELETE_FB_REVIEW_INT = action('DELETE_FB_REVIEW_INT');

export const getFBReviewInt = data => ({ type: GET_FB_REVIEW_INT, data });
export const createFBReviewInt = data => ({ type: CREATE_FACEBOOK_REVIEW_INTEGRATION, data });
export const createFBReviewIntIA = data => ({ type: CREATE_FB_REVIEW_INT_IA, data });
export const deleteFBReviewIntIA = data => ({ type: DELETE_FB_REVIEW_INT_IA, data });
export const deleteFBReviewInt = data => ({ type: DELETE_FB_REVIEW_INT, data });

//GMB POST
export const GET_GMB_POST_INT = action('GET_GMB_POST_INT');
export const CREATE_IS_GOOGLE_POST_PAGE_TRUE = action('CREATE_IS_GOOGLE_POST_PAGE_TRUE');
export const DELETE_IS_GOOGLE_POST_PAGE_FALSE = action('DELETE_IS_GOOGLE_POST_PAGE_FALSE');
export const DELETE_GMB_POST_INT = action('DELETE_GMB_POST_INT');

export const getGGLPostInt = data => ({ type: GET_GMB_POST_INT, data });
export const createGMBPostIntIA = data => ({ type: CREATE_IS_GOOGLE_POST_PAGE_TRUE, data });
export const deleteGGLPostIntIA = data => ({ type: DELETE_IS_GOOGLE_POST_PAGE_FALSE, data });
export const deleteGGLPostInt = data => ({ type: DELETE_GMB_POST_INT, data });

//GMB REVIEW
export const CREATE_GMB_REVIEW_INT = action('CREATE_GMB_REVIEW_INT');
export const GET_GMB_REVIEW_INT = action('GET_GMB_REVIEW_INT');
export const CREATE_IS_GOOGLE_REVIEW_PAGE_TRUE = action('CREATE_IS_GOOGLE_REVIEW_PAGE_TRUE');
export const DELETE_IS_GOOGLE_REVIEW_PAGE_FALSE = action('DELETE_IS_GOOGLE_REVIEW_PAGE_FALSE');
export const DELETE_GMB_REVIEW_INT = action('DELETE_GMB_REVIEW_INT');
export const SYNC_LASTEST_PAGES = action('SYNC_LASTEST_PAGES');

export const getGGLReviewInt = data => ({ type: GET_GMB_REVIEW_INT, data });
export const createGGLReviewInt = data => ({ type: CREATE_GMB_REVIEW_INT, data });
export const createGGLReviewIntIA = data => ({ type: CREATE_IS_GOOGLE_REVIEW_PAGE_TRUE, data });
export const deleteGGLReviewIntIA = data => ({ type: DELETE_IS_GOOGLE_REVIEW_PAGE_FALSE, data });
export const deleteGGLReviewInt = data => ({ type: DELETE_GMB_REVIEW_INT, data });
export const syncLastestPages = data => ({ type: SYNC_LASTEST_PAGES, data });

//TWITTER POST
export const CREATE_TWIT_POST_INT = action('CREATE_TWIT_POST_INT');
export const GET_TWIT_POST_INT = action('GET_TWIT_POST_INT');
export const DELETE_TWIT_POST_INT = action('DELETE_TWIT_POST_INT');
export const UPDATEFILTER = action('UPDATEFILTER');

export const getTwitPostInt = data => ({ type: GET_TWIT_POST_INT, data });
export const createTwitterUN = data => ({ type: CREATE_TWIT_POST_INT, data });
export const deleteTwitter = data => ({ type: DELETE_TWIT_POST_INT, data });
export const updateFilter = data => ({ type: UPDATEFILTER, data });

//Instagram post
export const GET_INSTA_POST_INT = action('GET_INSTA_POST_INT');
export const CREATE_INSTA_POST_INT = action('CREATE_INSTA_POST_INT');
export const DELETE_INSTA_POST_INT = action('DELETE_INSTA_POST_INT');
export const DELETE_INSTA_POST = action('DELETE_INSTA_POST');

export const getInstaPostInt = () => ({ type: GET_INSTA_POST_INT });
export const createInstaPostInt = data => ({ type: CREATE_INSTA_POST_INT, data });
export const deleteInstaPostInt = data => ({ type: DELETE_INSTA_POST_INT, data });
export const deleteInstaPost = data => ({ type: DELETE_INSTA_POST, data });

//Google place review
export const GET_GOOGLE_PLACE = action('GET_GOOGLE_PLACE');
export const CREATE_GOOGLEPLACE = action('CREATE_GOOGLEPLACE');
export const DELETE_GOOGLE_PLACE = action('DELETE_GOOGLE_PLACE');

export const getGooglePlace = data => ({ type: GET_GOOGLE_PLACE, data });
export const createGooglePlace = data => ({ type: CREATE_GOOGLEPLACE, data });
export const deleteGooglePlace = data => ({ type: DELETE_GOOGLE_PLACE, data });

//capterra review
export const GET_CAPTERRA = action('GET_CAPTERRA');
export const CREATE_CAPTERRA = action('CREATE_CAPTERRA');
export const DELETE_CAPTERRA = action('DELETE_CAPTERRA');
export const SYNC_REVIEWS = action('SYNC_REVIEWS');

export const getCapterra = data => ({ type: GET_CAPTERRA, data });
export const createCapterra = data => ({ type: CREATE_CAPTERRA, data });
export const deleteCapterra = data => ({ type: DELETE_CAPTERRA, data });
export const syncReviews = data => ({ type: SYNC_REVIEWS, data });

//webhook
export const GET_WEBHOOK = action('GET_WEBHOOK');
export const CREATE_WEBHOOK = action('CREATE_WEBHOOK');
export const DELETE_WEBHOOK = action('DELETE_WEBHOOK');
export const WEBHOOK_SUCCESS = action('WEBHOOK_SUCCESS');

export const webhookSuccess = data => ({ type: WEBHOOK_SUCCESS, data });
export const getWebhook = data => ({ type: GET_WEBHOOK, data });
export const createWebhook = data => ({ type: CREATE_WEBHOOK, data });
export const deleteWebhook = data => ({ type: DELETE_WEBHOOK, data });

export const TWITTER_OAUTH = action('TWITTER_OAUTH');
export const DELETE_UN_OR_TAG = action('DELETE_UN_OR_TAG');

export const twitterOauth = data => ({ type: TWITTER_OAUTH, data });
export const deleteUNorTag = data => ({ type: DELETE_UN_OR_TAG, data });

//Rss
export const GET_RSS = action('GET_RSS');
export const CREATE_RSS = action('CREATE_RSS');
export const DELETE_RSS = action('DELETE_RSS');

export const getRSS = data => ({ type: GET_RSS, data });
export const createRSS = data => ({ type: CREATE_RSS, data });
export const deleteRSS = data => ({ type: DELETE_RSS, data });

//Tumblr
export const GET_TUMBLR = action('GET_TUMBLR');
export const CREATE_TUMBLR = action('CREATE_TUMBLR');
export const DELETE_TUMBLR = action('DELETE_TUMBLR');

export const getTumblr = data => ({ type: GET_TUMBLR, data });
export const createTumblr = data => ({ type: CREATE_TUMBLR, data });
export const deleteTumblr = data => ({ type: DELETE_TUMBLR, data });

export const GET_WIDGET_FOR_INT = action('GET_WIDGET_FOR_INT');
export const GET_ACTIVE_WIDGET_SUCCESS = action('GET_ACTIVE_WIDGET_SUCCESS');

export const getWidgetForInt = data => ({ type: GET_WIDGET_FOR_INT, data });
export const widgetListSuccess = data => ({ type: GET_ACTIVE_WIDGET_SUCCESS, data });

//Booking
export const GET_BOOKING = action('GET_BOOKING');
export const CREATE_BOOKING = action('CREATE_BOOKING');
export const DELETE_BOOKING = action('DELETE_BOOKING');

export const getBooking = data => ({ type: GET_BOOKING, data });
export const createBooking = data => ({ type: CREATE_BOOKING, data });
export const deleteBooking = data => ({ type: DELETE_BOOKING, data });

//TripAdvisor
export const GET_TRIPADVISOR = action('GET_TRIPADVISOR');
export const CREATE_TRIPADVISOR = action('CREATE_TRIPADVISOR');
export const DELETE_TRIPADVISOR = action('DELETE_TRIPADVISOR');

export const getTripAdvisor = data => ({ type: GET_TRIPADVISOR, data });
export const createTripAdvisor = data => ({ type: CREATE_TRIPADVISOR, data });
export const deleteTripAdvisor = data => ({ type: DELETE_TRIPADVISOR, data });

//Trustpilot
export const GET_TRUSTPILOT = action('GET_TRUSTPILOT');
export const CREATE_TRUSTPILOT = action('CREATE_TRUSTPILOT');
export const DELETE_TRUSTPILOT = action('DELETE_TRUSTPILOT');

export const getTrustpilot = data => ({ type: GET_TRUSTPILOT, data });
export const createTrustpilot = data => ({ type: CREATE_TRUSTPILOT, data });
export const deleteTrustpilot = data => ({ type: DELETE_TRUSTPILOT, data });

//Airbnb
export const GET_AIRBNB = action('GET_AIRBNB');
export const CREATE_AIRBNB = action('CREATE_AIRBNB');
export const DELETE_AIRBNB = action('DELETE_AIRBNB');

export const getAirbnb = data => ({ type: GET_AIRBNB, data });
export const createAirbnb = data => ({ type: CREATE_AIRBNB, data });
export const deleteAirbnb = data => ({ type: DELETE_AIRBNB, data });

//Yelp
export const GET_YELP = action('GET_YELP');
export const CREATE_YELP = action('CREATE_YELP');
export const DELETE_YELP = action('DELETE_YELP');

export const getYelp = data => ({ type: GET_YELP, data });
export const createYelp = data => ({ type: CREATE_YELP, data });
export const deleteYelp = data => ({ type: DELETE_YELP, data });

//Hotels
export const GET_HOTELS = action('GET_HOTELS');
export const CREATE_HOTELS = action('CREATE_HOTELS');
export const DELETE_HOTELS = action('DELETE_HOTELS');

export const getHotels = data => ({ type: GET_HOTELS, data });
export const createHotels = data => ({ type: CREATE_HOTELS, data });
export const deleteHotels = data => ({ type: DELETE_HOTELS, data });

//Etsy
export const GET_ETSY = action('GET_ETSY');
export const CREATE_ETSY = action('CREATE_ETSY');
export const DELETE_ETSY = action('DELETE_ETSY');

export const getEtsy = data => ({ type: GET_ETSY, data });
export const createEtsy = data => ({ type: CREATE_ETSY, data });
export const deleteEtsy = data => ({ type: DELETE_ETSY, data });

//Houzz
export const GET_HOUZZ = action('GET_HOUZZ');
export const CREATE_HOUZZ = action('CREATE_HOUZZ');
export const DELETE_HOUZZ = action('DELETE_HOUZZ');

export const getHouzz = data => ({ type: GET_HOUZZ, data });
export const createHouzz = data => ({ type: CREATE_HOUZZ, data });
export const deleteHouzz = data => ({ type: DELETE_HOUZZ, data });

//Edmunds
export const GET_EDMUNDS = action('GET_EDMUNDS');
export const CREATE_EDMUNDS = action('CREATE_EDMUNDS');
export const DELETE_EDMUNDS = action('DELETE_EDMUNDS');

export const getEdmunds = data => ({ type: GET_EDMUNDS, data });
export const createEdmunds = data => ({ type: CREATE_EDMUNDS, data });
export const deleteEdmunds = data => ({ type: DELETE_EDMUNDS, data });

//DealerRater
export const GET_DEALERRATER = action('GET_DEALERRATER');
export const CREATE_DEALERRATER = action('CREATE_DEALERRATER');
export const DELETE_DEALERRATER = action('DELETE_DEALERRATER');

export const getDealerRater = data => ({ type: GET_DEALERRATER, data });
export const createDealerRater = data => ({ type: CREATE_DEALERRATER, data });
export const deleteDealerRater = data => ({ type: DELETE_DEALERRATER, data });

//OpenTable
export const GET_OPENTABLE = action('GET_OPENTABLE');
export const CREATE_OPENTABLE = action('CREATE_OPENTABLE');
export const DELETE_OPENTABLE = action('DELETE_OPENTABLE');

export const getOpenTable = data => ({ type: GET_OPENTABLE, data });
export const createOpenTable = data => ({ type: CREATE_OPENTABLE, data });
export const deleteOpenTable = data => ({ type: DELETE_OPENTABLE, data });

//eBay
export const GET_EBAY = action('GET_EBAY');
export const CREATE_EBAY = action('CREATE_EBAY');
export const DELETE_EBAY = action('DELETE_EBAY');

export const geteBay = data => ({ type: GET_EBAY, data });
export const createeBay = data => ({ type: CREATE_EBAY, data });
export const deleteeBay = data => ({ type: DELETE_EBAY, data });

//BBB
export const GET_BBB = action('GET_BBB');
export const CREATE_BBB = action('CREATE_BBB');
export const DELETE_BBB = action('DELETE_BBB');

export const getBBB = data => ({ type: GET_BBB, data });
export const createBBB = data => ({ type: CREATE_BBB, data });
export const deleteBBB = data => ({ type: DELETE_BBB, data });

//Amzon
export const GET_AMZON = action('GET_AMZON');
export const CREATE_AMZON = action('CREATE_AMZON');
export const DELETE_AMZON = action('DELETE_AMZON');

export const getAmzon = data => ({ type: GET_AMZON, data });
export const createAmzon = data => ({ type: CREATE_AMZON, data });
export const deleteAmzon = data => ({ type: DELETE_AMZON, data });

//GooglePlay
export const GET_GOOGLE_PLAY = action('GET_GOOGLE_PLAY');
export const CREATE_GOOGLE_PLAY = action('CREATE_GOOGLE_PLAY');
export const DELETE_GOOGLE_PLAY = action('DELETE_GOOGLE_PLAY');

export const getGooglePlay = data => ({ type: GET_GOOGLE_PLAY, data });
export const createGooglePlay = data => ({ type: CREATE_GOOGLE_PLAY, data });
export const deleteGooglePlay = data => ({ type: DELETE_GOOGLE_PLAY, data });

//AppleAPP
export const GET_APPLE_APP = action('GET_APPLE_APP');
export const CREATE_APPLE_APP = action('CREATE_APPLE_APP');
export const DELETE_APPLE_APP = action('DELETE_APPLE_APP');

export const getAppleAPP = data => ({ type: GET_APPLE_APP, data });
export const createAppleAPP = data => ({ type: CREATE_APPLE_APP, data });
export const deleteAppleAPP = data => ({ type: DELETE_APPLE_APP, data });

//Custom Loader
export const IS_LOADER_SUCCESS = action('IS_LOADER_SUCCESS');
export const successLoader = data => ({ type: IS_LOADER_SUCCESS, data });

//get user integration list
export const GET_USR_INTEGRATION = action('GET_USR_INTEGRATION');
export const GET_USR_INTEGRATION_SUCCESS = action('GET_USR_INTEGRATION_SUCCESS');

export const getUsrIntegration = data => ({ type: GET_USR_INTEGRATION, data });
export const getUsrIntegrationSuccess = data => ({ type: GET_USR_INTEGRATION_SUCCESS, data });

//getReviews
export const GET_REVIEWS = action('GET_REVIEWS');
export const SUCCESS_REVIEW_DATA = action('SUCCESS_REVIEW_DATA');

export const getReviews = data => ({ type: GET_REVIEWS, data });
export const sucessReviewData = data => ({ type: SUCCESS_REVIEW_DATA, data });

//AppSumo
export const GET_APPSUMO = action('GET_APPSUMO');
export const CREATE_APPSUMO = action('CREATE_APPSUMO');
export const DELETE_APPSUMO = action('DELETE_APPSUMO');

export const getAppSumo = data => ({ type: GET_APPSUMO, data });
export const createAppSumo = data => ({ type: CREATE_APPSUMO, data });
export const deleteAppSumo = data => ({ type: DELETE_APPSUMO, data });

//updateReview
export const UPDATE_REVIEW = action('UPDATE_REVIEW');
export const UPDATE_REVIEW_SUCCESS = action('UPDATE_REVIEW_SUCCESS');

export const updateReview = data => ({ type: UPDATE_REVIEW, data });
export const updateReviewSuccess = data => ({ type: UPDATE_REVIEW_SUCCESS, data });

//getImages
export const GET_IMAGES = action('GET_IMAGES');
export const SUCCESS_GET_IMAGES = action('SUCCESS_GET_IMAGES');

export const getImages = data => ({ type: GET_IMAGES, data });
export const iconSuccess = data => ({ type: SUCCESS_GET_IMAGES, data });

//deleteImage
export const DELETE_IMAGE = action('DELETE_IMAGE');

export const deleteImage = data => ({ type: DELETE_IMAGE, data });

//setIconImageURL
export const SET_ICON_IMAGE_URL = action('SET_ICON_IMAGE_URL');

export const setIconImageURL = data => ({ type: SET_ICON_IMAGE_URL, data });

//deleteReview
export const DELETE_REVIEW = action('DELETE_REVIEW');
export const DELETE_REVIEW_SUCCESS = action('DELETE_REVIEW_SUCCESS');

export const deleteReview = data => ({ type: DELETE_REVIEW, data });
export const deleteReviewSuccess = data => ({ type: DELETE_REVIEW_SUCCESS, data });

//removeImage
export const REMOVE_IMAGE = action('REMOVE_IMAGE');

export const removeImage = data => ({ type: REMOVE_IMAGE, data });

//addCutomReview
export const ADD_CUTOM_REVIEW = action('ADD_CUTOM_REVIEW');

export const addCutomReview = data => ({ type: ADD_CUTOM_REVIEW, data });

//CustomReview
export const GET_CUSTOM_REVIEW = action('GET_CUSTOM_REVIEW');
export const CREATE_CUSTOM_REVIEW = action('CREATE_CUSTOM_REVIEW');
export const DELETE_CUSTOM_REVIEW = action('DELETE_CUSTOM_REVIEW');

export const getCustomReview = data => ({ type: GET_CUSTOM_REVIEW, data });
export const createCustomReview = data => ({ type: CREATE_CUSTOM_REVIEW, data });
export const deleteCustomReview = data => ({ type: DELETE_CUSTOM_REVIEW, data });

//downloadExcelData
export const DOWNLOAD_EXCEL_DATA = action('DOWNLOAD_EXCEL_DATA');
export const SUCCESS_DOWNLOAD_EXCEL_DATA = action('SUCCESS_DOWNLOAD_EXCEL_DATA');

export const downloadExcelData = data => ({ type: DOWNLOAD_EXCEL_DATA, data });
export const successDownloadExcelData = data => ({ type: SUCCESS_DOWNLOAD_EXCEL_DATA, data });

export const DELETE_CUST_REVIEW_INT = action('DELETE_CUST_REVIEW_INT');
export const deleteCustReviewInt = data => ({ type: DELETE_CUST_REVIEW_INT, data });

//CustomWebhook
export const GET_CUSTOM_WEBHOOK = action('GET_CUSTOM_WEBHOOK');
export const CREATE_CUSTOM_WEBHOOK = action('CREATE_CUSTOM_WEBHOOK');
export const DELETE_CUSTOM_WEBHOOK = action('DELETE_CUSTOM_WEBHOOK');
export const GET_CUSTOM_WB_FIELD = action('GET_CUSTOM_WB_FIELD');
export const SUCCESS_GET_CUSTOM_WB_FIELD = action('SUCCESS_GET_CUSTOM_WB_FIELD');
export const ADD_CUSTOM_FIELD = action('ADD_CUSTOM_FIELD');
export const DELETE_CUSTOM_FIELD = action('DELETE_CUSTOM_FIELD');
export const UPD_CUSTOM_FIELD = action('UPD_CUSTOM_FIELD');
export const GET_CUSTOM_COLLECTOR_REVIEW = action('GET_CUSTOM_COLLECTOR_REVIEW');
export const CREATE_CUSTOM_COLLECTOR_REVIEW = action('CREATE_CUSTOM_COLLECTOR_REVIEW');
export const DELETE_CUSTOM_COLLECTOR_REVIEW = action('DELETE_CUSTOM_COLLECTOR_REVIEW');

export const getCustomWebhook = data => ({ type: GET_CUSTOM_WEBHOOK, data });
export const createCustomWebhook = data => ({ type: CREATE_CUSTOM_WEBHOOK, data });
export const deleteCustomWebhook = data => ({ type: DELETE_CUSTOM_WEBHOOK, data });
export const getCustomWBField = data => ({ type: GET_CUSTOM_WB_FIELD, data });
export const successCustomWBField = data => ({ type: SUCCESS_GET_CUSTOM_WB_FIELD, data });
export const addCustomField = data => ({ type: ADD_CUSTOM_FIELD, data });
export const deleteCustomField = data => ({ type: DELETE_CUSTOM_FIELD, data });
export const updCustomField = data => ({ type: UPD_CUSTOM_FIELD, data });
export const getCustomCollectorReview = data => ({ type: GET_CUSTOM_COLLECTOR_REVIEW, data });
export const createCustomCollectorReview = data => ({ type: CREATE_CUSTOM_COLLECTOR_REVIEW, data });
export const deleteCustomCollectorReview = data => ({ type: DELETE_CUSTOM_COLLECTOR_REVIEW, data });

//Aliexpress
export const GET_ALIEXPRESS = action('GET_ALIEXPRESS');
export const CREATE_ALIEXPRESS = action('CREATE_ALIEXPRESS');
export const DELETE_ALIEXPRESS = action('DELETE_ALIEXPRESS');

export const getAliexpress = data => ({ type: GET_ALIEXPRESS, data });
export const createAliexpress = data => ({ type: CREATE_ALIEXPRESS, data });
export const deleteAliexpress = data => ({ type: DELETE_ALIEXPRESS, data });

//G2
export const GET_G2 = action('GET_G2');
export const CREATE_G2 = action('CREATE_G2');
export const DELETE_G2 = action('DELETE_G2');

export const getG2 = data => ({ type: GET_G2, data });
export const createG2 = data => ({ type: CREATE_G2, data });
export const deleteG2 = data => ({ type: DELETE_G2, data });

//YouTubeVideoGallery
export const GET_YOUTUBE_VIDEO_GALLERY = action('GET_YOUTUBE_VIDEO_GALLERY');
export const CREATE_YOUTUBE_VIDEO_GALLERY = action('CREATE_YOUTUBE_VIDEO_GALLERY');
export const DELETE_YOUTUBE_VIDEO_GALLERY = action('DELETE_YOUTUBE_VIDEO_GALLERY');

export const getYouTubeVideoGallery = data => ({ type: GET_YOUTUBE_VIDEO_GALLERY, data });
export const createYouTubeVideoGallery = data => ({ type: CREATE_YOUTUBE_VIDEO_GALLERY, data });
export const deleteYouTubeVideoGallery = data => ({ type: DELETE_YOUTUBE_VIDEO_GALLERY, data });

//stamped review
export const GET_STAMPED = action('GET_STAMPED');
export const CREATE_STAMPED = action('CREATE_STAMPED');
export const DELETE_STAMPED = action('DELETE_STAMPED');

export const getStamped = () => ({ type: GET_STAMPED });
export const createStamped = data => ({ type: CREATE_STAMPED, data });
export const deleteStamped = data => ({ type: DELETE_STAMPED, data });

export const CREATE_TUMBLR_POST_INT = action('CREATE_TUMBLR_POST_INT');
export const DELETE_TUMBLR_POST_INT = action('DELETE_TUMBLR_POST_INT');

export const createTumblrPostInt = data => ({ type: CREATE_TUMBLR_POST_INT, data });
export const deleteTumblrPostInt = data => ({ type: DELETE_TUMBLR_POST_INT, data });

export const GET_IMPORT_REVIEW = action('GET_IMPORT_REVIEW');
export const CREATE_IMPORT_REVIEW = action('CREATE_IMPORT_REVIEW');
export const DELETE_IMPORT_REVIEW = action('DELETE_IMPORT_REVIEW');

export const getImportreview = data => ({ type: GET_IMPORT_REVIEW, data });
export const createImportReview = data => ({ type: CREATE_IMPORT_REVIEW, data });
export const deleteImportReview = data => ({ type: DELETE_IMPORT_REVIEW, data });

export const UPLOAD_CSV = action('UPLOAD_CSV');

export const uploadCSV = data => ({ type: UPLOAD_CSV, data });

export const INT_SUCCESS_LOADER = action('INT_SUCCESS_LOADER');
export const intSuccessLoader = data => ({ type: INT_SUCCESS_LOADER, data });

//TwitterTestimonial
export const GET_TWITTER_TESTIMONIAL = action('GET_TWITTER_TESTIMONIAL');
export const CREATE_TWITTER_TESTIMONIAL = action('CREATE_TWITTER_TESTIMONIAL');
export const DELETE_TWITTER_TESTIMONIAL = action('DELETE_TWITTER_TESTIMONIAL');

export const getTwitterTestimonial = data => ({ type: GET_TWITTER_TESTIMONIAL, data });
export const createTwitterTestimonial = data => ({ type: CREATE_TWITTER_TESTIMONIAL, data });
export const deleteTwitterTestimonial = data => ({ type: DELETE_TWITTER_TESTIMONIAL, data });

const initialState = fromJS({});

const integration = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIVE_USER_AND_MST_INT_SUCCESS:
      return state.set('userIntMst', action.data);
    case GET_ACTIVE_INT_SUCCESS:
      return state.set('integration', action.data);
    case INT_SUCCESS:
      return state.set('userIntegration', action.data);
    case WEBHOOK_SUCCESS:
      return state.set('webhooks', action.data);
    case GET_ACTIVE_WIDGET_SUCCESS:
      return state.set('widgetList', action.data);
    case IS_LOADER_SUCCESS:
      return state.set('isLoader', action.data);
    case GET_USR_INTEGRATION_SUCCESS:
      return state.set('lstUsrInt', action.data);
    case SUCCESS_REVIEW_DATA:
      return state.set('reviewsData', action.data);
    case SUCCESS_GET_IMAGES:
      return state.set('iconImages', action.data);
    case DELETE_REVIEW_SUCCESS:
      return state.set('deleteReviewID', action.data);
    case UPDATE_REVIEW_SUCCESS:
      return state.set('updReview', action.data);
    case SUCCESS_DOWNLOAD_EXCEL_DATA:
      return state.set('excelDownload', action.data);
    case SUCCESS_GET_CUSTOM_WB_FIELD:
      return state.set('customWBField', action.data);
    case INT_SUCCESS_LOADER:
      return state.set('isIntLoader', action.data);
    default:
      return state;
  }
};

export default integration;


// WEBPACK FOOTER //
// ./src/ducks/integration.js